import type { MetricCategory } from '@mfw/common';

// Which registry keys belong to the morning vs. evening entry — a UX
// grouping, not a registry concept (the registry only knows `category`).

export const MORNING_KEYS = [
  'sleep_duration',
  'sleep_rem_min',
  'sleep_deep_min',
  'sleep_light_min',
  'sleep_score',
  'morning_hr',
  'blood_sugar_am',
  'bp_systolic_am',
  'bp_diastolic_am',
  'sleep_wakeups',
];

// Evening spans 3 registry categories — rendered as horizontal tabs, same
// component the Exercises/Workouts/Programs library uses.
export const EVENING_CATEGORY_TABS: MetricCategory[] = [
  'activity',
  'nutrition',
  'health',
] as MetricCategory[];

export const EVENING_KEYS_BY_CATEGORY: Record<string, string[]> = {
  activity: ['steps', 'distance', 'floors', 'calories_burned'],
  health: [
    'stress_overall',
    'mood',
    'blood_sugar_pm',
    'bp_systolic_pm',
    'bp_diastolic_pm',
  ],
  nutrition: [
    'water_intake',
    'kcal_intake_breakfast',
    'kcal_intake_morning_snack',
    'kcal_intake_lunch',
    'kcal_intake_afternoon_snack',
    'kcal_intake_dinner',
  ],
};

export const EVENING_KEYS = Object.values(EVENING_KEYS_BY_CATEGORY).flat();

// steps/distance/calories_burned "+ portion from workout" — which registry
// key's unit/display each workoutBreakdown field follows (KpiService.
// activityBreakdownForDay, not a registry metric of its own).
export const WORKOUT_BREAKDOWN_METRIC_KEY = {
  distance: 'distance',
  kcal: 'calories_burned',
  steps: 'steps',
} as const;
